module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#video",
      toString: function () {
        return this.url;
      }
    }